import React from 'react';  
import { motion } from 'framer-motion';  
import { Play } from 'lucide-react';  
  
const CartaActual = ({ carta, onHablar }) => {  
  return (  
    <motion.div  
      className="bg-gradient-to-br from-yellow-400 to-orange-500 rounded-3xl p-8 text-center shadow-2xl relative overflow-hidden"  
      initial={{ scale: 0.9, opacity: 0 }}  
      animate={{ scale: 1, opacity: 1 }}  
      transition={{ duration: 0.5, type: "spring" }}  
    >  
      <div className="absolute top-4 right-4">  
        <button  
          onClick={onHablar}  
          className="bg-white/20 hover:bg-white/30 rounded-full p-3"  
        >  
          <Play className="w-6 h-6 text-white" />  
        </button>  
      </div>  
      <div className="w-80 h-80 bg-white/20 rounded-2xl mx-auto mb-6 flex items-center justify-center overflow-hidden">  
        {/* Contenedor más grande para imagen completa */}  
        <img  
          src={carta.image_url}  
          alt={carta.descripcion}  
          className="w-full h-full object-contain"  // Cambiado a contain para mostrar completa sin recorte  
          onError={(e) => {  
            e.target.style.display = 'none';  
            e.target.nextSibling.style.display = 'block';  
          }}  
        />  
        <span className="text-6xl font-serif hidden">🎴</span>  
      </div>  
      <h2 className="text-4xl font-bold text-white mb-2">{carta.descripcion}</h2>  
    </motion.div>  
  );  
};  
  
export default CartaActual;